<template>
  <div>
    <List v-for="sys in canLoginSystemList" :id="sys.id" :key="sys.id">
      <div
        @click="cellDidClicked(sys)"
        style="border-bottom: solid 1px #F3F3F3;"
        class="cell"
      >
        <ListItem>
          <ListItemMeta :title="sys.appName"> </ListItemMeta>
          <template #extra>
            <Icon type="ios-arrow-forward" />
          </template>
        </ListItem>
      </div>
    </List>
  </div>
</template>
<script>
export default {
  props: {
    canLoginSystemList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    cellDidClicked(sys) {
      this.$emit('didClickCell', sys);
    }
  }
};
</script>
<style scoped>
  .cell:hover{
    cursor: pointer;
  }
</style>
